<script lang="ts" setup>
import { Button } from '@forgd/ui-kit/button'
import { ArrowLeftIcon } from '@heroicons/vue/24/outline'

const auth = useAuth()
const rfqDetails = useRFQDetails()
const isDemoMode = useRfqDemoMode()

useHead({
  title: 'Compare Quotes',
})

if (auth.project) {
  await rfqDetails.fetch()
}

const backLink = computed(() => {
  const round = rfqDetails.data?.rfq?.round ?? 1
  return round === 2
    ? '/engage-a-market-maker/received-requotes'
    : '/engage-a-market-maker/received-quotes'
})

// getProjectPath would produce /project/default/... on the project-less demo route.
const backTo = computed(() => (isDemoMode.value ? '/engage-a-market-maker/demo' : getProjectPath(backLink.value)))
</script>

<template>
  <NuxtLayout name="dashboard" container-layout="fluid" app-footer-class="max-md:hidden" :page-header="{ description: 'Free Tools', title: 'Engage with New Market Makers', icon: '/icons/engage-with-new-market-makers.svg' }">
    <!-- Empty sidebar slot keeps the app menu rail collapsed (core-dashboard only
         expands it on wide screens when no sidebar slot is present). -->
    <template #sidebar>
      <div class="w-0 overflow-hidden" aria-hidden="true" />
    </template>

    <template #header>
      <div class="flex items-center gap-3">
        <Button as-child variant="outline" size="sm">
          <NuxtLink :to="backTo">
            <ArrowLeftIcon aria-hidden="true" />
            Back to RFQ
          </NuxtLink>
        </Button>
        <div class="flex items-center gap-2">
          <img
            src="/icons/engage-with-new-market-makers.svg"
            alt="Engage with New Market Makers"
            class="h-8"
          >
          <div class="shrink-0 text-sm font-semibold">
            Engage with New Market Makers
          </div>
        </div>
      </div>
    </template>

    <template #page-header-prefix>
      <Button as-child variant="outline" size="sm">
        <NuxtLink :to="backTo">
          <ArrowLeftIcon aria-hidden="true" />
          Back to RFQ
        </NuxtLink>
      </Button>
    </template>

    <div class="w-full">
      <slot />
    </div>
  </NuxtLayout>
</template>
